module.exports = __webpack_public_path__ + "static/media/royal-accolades.8d88d1b7.svg";